import { change, destroy, Field, reduxForm } from "redux-form";
import Button from "components/atoms/Button";
import ReduxFormFields from "components/molecules/ReduxFormFields";
import InputRedux from "components/molecules/InputRedux";
import SelectRedux from "components/molecules/SelectRedux";
import CheckboxRedux from "components/molecules/CheckboxRedux";
import PhoneInputRedux from "components/molecules/PhoneInputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields";
import {
  email,
  minLength3,
  phone,
  required,
  requiredPhone,
  requiredSelect,
} from "utils/validate.util";
import { Box, Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import PersistReduxForm from "components/organisms/PersistReduxForm";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ObjectService from "utils/object.util";
import LocalStorage from "utils/localstorage.util";
import FlightNumber from "./FlightNumber";

function AdditionalInfoForm({ handleSubmit, form }: any) {
  const { t } = useTranslation("translation");

  const fields: ReduxFormField[] = [
    {
      name: "pickup_sign",
      label: t("pickUpSign"),
      component: InputRedux,
      cellProps: { md: 12 },
    },
    {
      name: "notes",
      label: t("notesForChauffeur"),
      component: InputRedux,
      cellProps: { md: 12 },
      InputProps: { multiline: true, rows: 3 },
    },
  ];

  const additional_fields = (airport: any): ReduxFormField[] => [
    {
      name: "title",
      label: t("title"),
      component: SelectRedux,
      validate: [requiredSelect],
      SelectProps: {
        options: [
          { value: "Mr.", label: t("mr") },
          { value: "Ms.", label: t("ms") },
        ],
      },
      cellProps: { md: 12 },
    },
    {
      name: "first_name",
      label: t("firstName"),
      component: InputRedux,
      validate: [required],
      cellProps: { md: 12 },
    },
    {
      name: "last_name",
      label: t("lastName"),
      component: InputRedux,
      validate: [required],
      cellProps: { md: 12 },
    },
    ...(airport
      ? [
          {
            name: "flight_number",
            label: t("flightNumber"),
            component: FlightNumber,
            validate: [required, minLength3],
            cellProps: { md: 12 },
          },
        ]
      : []),
    // {
    //   name: "phone",
    //   label: t("Phone"),
    //   component: PhoneInputRedux,
    //   cellProps: { md: 12 },
    // },
  ];
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  // const booking_for_someone = useAppSelector((state) => state.form?.[form]?.values?.booking_for_someone);
  // const pickup_sign = useAppSelector(
  //   (state) => state.form?.[form]?.values?.pickup_sign
  // );

  const searchTripFormValues = useAppSelector(
    (state) => state.form?.PickUpForm?.values
  );
  const airport = searchTripFormValues?.pickup?.details?.airport;

  useEffect(() => {
    if (!user) return;
    dispatch(change(form, "first_name", user?.first_name));
    dispatch(change(form, "last_name", user?.last_name));
    dispatch(change(form, "email", user?.email));
    // dispatch(change(form, "phone", { value: user?.phoneNumber }));

    dispatch(
      change(form, "pickup_sign", ObjectService.getFullName(user, false))
    );
    // Retrieve and set values from localStorage
  }, [user]);

  useEffect(() => {
    const storedValues = LocalStorage.getItem(form);
    if (storedValues) {
      Object.keys(storedValues).forEach((key) => {
        dispatch(change(form, key, storedValues[key]));
      });
    }
  }, []);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container columnSpacing={6}>
          <Grid item xs={12}>
            <Box mb={2}>
              <ReduxFormFields fields={additional_fields(airport)} />
            </Box>
            {/* {airport && (
              <Box mb={2}>
                <Field
                  name="flight_number"
                  label={t("flightNumber")}
                  component={FlightNumber}
                  validate={[required, minLength3]}
                />
              </Box>
            )} */}
            <Box mb={2}>
              <Field
                name="email"
                label={t("email")}
                component={InputRedux}
                validate={[email]}
              />
            </Box>
            <Box mb={2}>
              <ReduxFormFields fields={fields} />
            </Box>
            <Button
              sx={{
                height: "48px",
                marginLeft: "auto",
                display: "flex",
                borderRadius: "25px",
                justifyContent: "center",
              }}
              color="info"
              variant="contained"
              type="submit"
              fullWidth
            >
              {t("continue")}
            </Button>
          </Grid>
        </Grid>
      </form>
      <PersistReduxForm form={form} />
    </div>
  );
}

export default reduxForm({
  form: "AdditionalInfoForm",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AdditionalInfoForm);
